<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label || '연도'"
      @remove="onClickFilterRemove"
    >
      <div class="flex items-center gap-2">
        <vs-select class="w-full" autocomplete v-model="year" @change="change" :disabled="readonly">
          <vs-select-item v-for="(year, index) in years" :key="index" :text="year.text" :value="year.value" />
        </vs-select>
        {{ afterFix }}
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="labelHidden" :columns="gridTemplateColumns">
      <div class="flex items-center gap-2">
        <vs-select class="w-full" :class="{'xl:w-32': !xlWidthFull}" autocomplete v-model="year" @change="change" :disabled="readonly">
          <vs-select-item v-for="(year, index) in years" :key="index" :text="year.text" :value="year.value" />
        </vs-select>
        <span v-if="!isMobile">{{ afterFix }}</span>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchYear",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "연도",
      type: String,
    },
    value: [String, Number],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'year': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.year = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    defaultValue () {
      return this.options && this.options['default'] ? this.options['default'] : "";
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : undefined;
    },
    initData() {
      const defaultValue = this.defaultValue;
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const year = query[_query_keys[0]];
      if (year) {
        try {
          return {
            year: year || defaultValue,
          };
        } catch (e) {}
      }
      return {
        year: defaultValue,
      };
    },
    maxYear () {
      return this.options && this.options.maxYear || '';
    },
    useAll () {
      return this.options && this.options.useAll || false;
    },
    years() {
      const years = [];
      let currentYear = new Date().getFullYear();
      if (this.maxYear) {
        currentYear = this.maxYear;
      }
      if (this.useAll) {
        years.push({ text: "전체", value: "" });
      }
      for (let i = currentYear; i >= 2010; i--) {
        years.push({ text: `${i}${this.unit}`, value: i });
      }
      return years;
    },
    labelHidden() {
      // labelHiddenResolution 이상의 해상도에서는 label 을 보여주지 않음
      const target = this.labelHiddenResolution;
      const screens = this.$viewport.screens;
      const start = screens.indexOf(target);
      if (start > -1) {
        for (let i = start; i < screens.length; i++) {
          if (this.$viewport.screen === screens[i]) {
            return true;
          }
        }
      }

      if (this.isMobile || !this.lastLabel) {
        return false;
      }
      return true;
    },
    afterFix() {
      return this.options && this.options.afterFix || "";
    },
    labelHiddenResolution () {
      return this.options && this.options.labelHiddenResolution || 'none'
    },
    unit() {
      if (!this.options || this.options.unit === '') return '';
      return this.options.unit || "년";
    },
    xlWidthFull() {
      return this.options && this.options.xlWidthFull || false;
    },
    lastLabel () {
      if (this.options && this.options.lastLabel) {
        return this.options.lastLabel;
      }
      return false;
    },

    // label 을 보여주기 위한 조건
    showLabel() {
      // mobile, pc
      return this.options && this.options.showLabel || 'all';
    },
  },
  data() {
    return {
      year: "",
    };
  },
  created() {
    this.year = this.initData.year;
    this.$emit("input", this.year);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      const year = data.target ? this.year : data;
      this.$emit("input", year);

      const dateKey = this.options && this.options.autoFillDateKey;
      if (dateKey && this.options.nav) {
        this.$set(this.options.nav, dateKey, {
          startDate: `${year}-01-01`,
          endDate:   `${year}-12-31`,
        });
      }
    },
    onClickFilterRemove () {
      this.year = this.defaultValue;
      this.$emit("input", this.year);
    }
  },
};
</script>
